export const CHART_MENU_ITEMS = [
  { key: 'fullscreen', label: 'View in full screen', readOnlyCheck: false },
  { key: 'print_chart', label: 'Print chart', readOnlyCheck: true },
  { key: 'download_png', label: 'Download PNG image', readOnlyCheck: true },
  { key: 'download_jpeg', label: 'Download JPEG image', readOnlyCheck: true },
  { key: 'download_pdf', label: 'Download PDF document', readOnlyCheck: true },
];
